// extracted by mini-css-extract-plugin
export var contactServices = "style-mod--contact-services--a35c8";
export var customServiceModal = "style-mod--custom-service-modal--6f2cd";
export var customerContactContent = "style-mod--customer-contact-content--36b45";
export var customerContactEmail = "style-mod--customer-contact-email--a239c";
export var customerContactFeedback = "style-mod--customer-contact-feedback--af521";
export var customerContactFeedbackTitle = "style-mod--customer-contact-feedback-title--94707";
export var customerContactHead = "style-mod--customer-contact-head--f083f";
export var customerContactHeadTitle = "style-mod--customer-contact-head-title--8c8bb";
export var customerContactImage = "style-mod--customer-contact-image--017da";
export var customerContactImageItem = "style-mod--customer-contact-image-item--9c47e";
export var customerContactInfo = "style-mod--customer-contact-info--ce012";
export var customerContactInfoIcon = "style-mod--customer-contact-info-icon--377ac";
export var customerContactParagraph = "style-mod--customer-contact-paragraph--d5958";
export var customerContactTel = "style-mod--customer-contact-tel--30252";
export var customerContactText = "style-mod--customer-contact-text--11f5f";
export var customerContactTextTitle = "style-mod--customer-contact-text-title--1ca00";
export var desktopImage = "style-mod--desktop-image--0b119";
export var desktopVersion = "style-mod--desktop-version--3f0e9";
export var mobileImage = "style-mod--mobile-image--8b9a2";
export var mobileVersion = "style-mod--mobile-version--c0604";
export var modalClose = "style-mod--modal-close--c8aaa";
export var modalCloseContainer = "style-mod--modal-close-container--1ec99";
export var modalCloseDesktop = "style-mod--modal-close-desktop--d69ba";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--69386";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--9d4f9";
export var modalCloseResponsive = "style-mod--modal-close-responsive--42459";
export var modalParagraph = "style-mod--modal-paragraph--1b2f1";
export var modalTitle = "style-mod--modal-title--c3cad";